import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridCellParams } from '@mui/x-data-grid';
import clsx from 'clsx';
import { useSelector } from '../../store/store';
import { v2api, v2apiBlob } from '../../api/axios';
import { statusType } from 'aws-sdk/clients/iam';
import fileDownload from 'js-file-download';

// カラム定義
const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 10 },
  {
    field: 'chargeDate',
    headerName: '決済日時',
    width: 150,
  },
  {
    field: 'amount',
    headerName: '決済金額',
    width: 100,
  },
  {
    field: 'status',
    headerName: '結果',
    width: 250,
    cellClassName: (params: GridCellParams<string>) => {
      if (params.value == null) {
        return '';
      }

      return clsx('super-app', {
        negative: params.value.includes('失敗'),
        positive: params.value.includes('成功'),
      });
    },
  },
  {
    field: 'receipt',
    headerName: '領収書',
    width: 150,
    cellClassName: (params: GridCellParams<string>) => {
      if (params.value == null) {
        return '';
      }

      return clsx('super-app', {
        positive: params.value.includes('Download'),
      });
    },
  },
  { field: 'chargeId', headerName: '支払ID', width: 10 },
];
interface RowProps {
  id: number;
  chargeDate: string;
  amount: string;
  status: statusType;
  receipt: string;
  chargeId: string;
}
export default function Charges() {
  // ストアからユーザー情報を取得
  const user = useSelector((state) => state.loginUser.user);

  const [rows, setRows] = useState<RowProps[] | undefined | any>([]);
  useEffect(() => {
    (async () => {
      try {
        // 最新の支払い情報を取得する
        const postData = {
          userId: user.id,
          token: user.access_token,
        };
        const res = await v2api.post('/get-stripe-customer-charges', postData);
        if (res.data.statusCode === 200) {
          const body = JSON.parse(res.data.body);
          const currentRows = body.data.map((row: any, idx: number) => {
            const createDate = new Date(row.created * 1000);
            const rowData: RowProps = {
              id: idx,
              chargeDate: `${createDate.toLocaleDateString(
                'ja-JP',
              )} ${createDate.toLocaleTimeString('ja-JP')} `,
              amount: `${row.amount}円`,
              status: row.paid ? '成功' : `失敗(${row.failure_message})`,
              receipt: row.paid ? 'Download' : '',
              chargeId: row.id,
            };
            return rowData;
          });
          setRows(currentRows);
        }
      } catch (err: any) {
        throw err;
      }
    })();
  }, [user]);

  // セルがクリックされたときの処理
  const handleCellClick = async (params: GridCellParams) => {
    if (params.field !== 'receipt') {
      return;
    }
    // 領収書宛名を確認する
    if (!user?.receipt_name) {
      alert('領収書宛名が登録されていません。\n「アカウント設定」から領収書宛名を設定してください。');
      return;
    }
    const chargeId = params.row.chargeId;
    const chargeDate = params.row.chargeDate.split(' ')[0];
    alert(chargeDate + 'の領収書をダウンロードします。\n「OK」を押して、しばらくお待ちください。');
    // 領収書PDFをダウンロードする
    (async () => {
      const postData = {
        userId: user.id,
        token: user.access_token,
        chargeId: chargeId,
      };
      try {
        const res = await v2apiBlob.post('/get-receipt-pdf', postData);
        fileDownload(res.data, `transrec_receipt_${chargeDate}.pdf`);
      } catch (err: any) {
        throw err;
      }
    })();
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        '& .super-app.negative': {
          color: '#f50057',
        },
        '& .super-app.positive': {
          color: '#2196f3',
        },
      }}
    >
      <DataGrid
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
              chargeId: false,
            },
          },
        }}
        rows={rows}
        columns={columns}
        pageSize={7}
        rowsPerPageOptions={[7]}
        onCellClick={handleCellClick}
      />
    </Box>
  );
}
